import api from '.'

export const stageGroups = {
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/stage-groups`, data, success, fail)
  },
  listForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/stage-groups`, null, success, fail)
  },
  update (groupId, data, success, fail) {
    api.authenticatedRequest('PUT', `/stage-groups/${groupId}`, data, success, fail)
  },
  delete (groupId, success, fail) {
    api.authenticatedRequest('DELETE', `/stage-groups/${groupId}`, null, success, fail)
  }
}
